import { catchError } from "../../utils/Helper";
import { leave } from "../axios/endpoint";
import { getRequest } from "../axios/request";

export const getLeaveDetails = async (query, signal) => {
  try {
    const response = await getRequest(leave.getLeaves, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const leaveApi = {
  getLeaveDetails,
};
